<div class="logout-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
                [class.component-dark-theme]="themeService.isDark()"
            >
                <div class="title text-center">
                    <h3>
                        Sesión finalizada!
                    </h3>
                    <p class="ml-auto mr-auto">
                        Gracias por usar mitorneo.app
                    </p>
                </div>
                <div class="admin text-center">
                    <div class="logo position-relative rounded-circle">
                        <img src="images/logo.svg" alt="logo">
                    </div>
                    <!-- <span class="d-block fw-medium">
                        You Are Logged out
                    </span> -->
                </div>
                <a routerLink="/auth" mat-button class="btn">
                    Ingresar
                </a>
            </div>
        </div>
    </div>
</div>
